import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import $ from 'jquery';

// Overlay loading untuk halaman rapor. isLoading true sejak awal: halaman langsung memuat data pertama.
export default {
    components: { Loading },
    data() {
        return { isLoading: true };
    },
    methods: {
        // Tabel DataTables server-side: tampilkan loading tiap request (muat awal, cari, ganti halaman)
        trackTableLoading(el) {
            $(el)
                .on('preXhr.dt', () => { this.isLoading = true; })
                .on('xhr.dt error.dt draw.dt', () => { this.isLoading = false; });
        },
    },
};
